<template>
  <div>
    <MainHeader @changeRouterFn="changeRouterFn" @openOrder="openOrder" />
    <el-dialog
      custom-class="orderModal"
      :visible.sync="searchOrder"
      width="560px"
      center
      :close-on-click-modal="false"
    >
      <p class="title bold text-black text-center">扫码前往小程序查看</p>
      <div class="mt6 codeBg">
         <img src="https://static.zc0901.com/dci/series/code-2.jpg" class="qrcode"/>
        <!-- <div class="qrcode" ref="qrCodeUrl">
         
        </div> -->
      </div>
    </el-dialog>
    <router-view />
  </div>
</template>

<script>
import MainHeader from "./components/header";
import QRCode from "qrcodejs2";
export default {
  name: "index",
  components: {
    MainHeader
  },
  data() {
    return {
      searchOrder: false,
      orderUrl: "https://www.baidu.com"
    };
  },
  mounted() {
    
  },
  methods: {
    openOrder() {
      this.searchOrder = true;     
    //   this.$nextTick(() => {
    //     //防止弹窗再次点击二维码dom重复
    //   this.$refs.qrCodeUrl.innerHTML=""
    //   this.creatQrCode();
    // });
    },
    creatQrCode() {
      let _this = this;
      var qrcode = new QRCode(_this.$refs.qrCodeUrl, {
        text: _this.orderUrl,
        width: 134,
        height: 134,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    changeRouterFn(type) {
      if (this.$router.history.current.path !== `/${type}`) {
        this.$router.push({
          path: `../${type}`
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 30px;
}
.codeBg {  
  width: 100%;
  height: 250px;
  background-image: url("https://static.zc0901.com/dci-miniapp/QR-code.png");
  background-size: cover;
  text-align: center;
  .qrcode {
    display: inline-block;
    width: 174px;
    height:204px;

  }
}
</style>
<style lang="scss">
.orderModal {
  .el-dialog__body {
    padding: 25px 0 0 !important;
  }
}
</style>
